import { Suspense } from "react";
import UniversalLoading from "@/components/loading/UniversalLoading";
import AdminDashboard from "@/components/admin/pages/AdminDashboard";

export const AdminDashboardView = () => {
  return (
    <Suspense
      fallback={
        <div className="overflow-y-hidden">
          <UniversalLoading 
            variant="admin" 
            message="Loading admin dashboard..." 
          />
        </div>
      }
    >
      <AdminDashboard />
    </Suspense>
  );
};

export default AdminDashboardView;
